import React, { useEffect, useState } from "react";
import { Card } from "antd";
import axios from "axios";
import PayrollReports from "../../../commons/Payroll/PayrollReports";
import { isAuthenticated } from "../../../commons/Auth/auth";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";

import { useTranslation } from "react-i18next";
/**
 * The employer view of the recurring payroll filings. The Lohnsteuerbescheinigung is per
 * employee, so the list of employees is loaded once for the picker.
 */
const PayrollReportsPage = () => {
  const { t } = useTranslation("dashboard");
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/employees/limited`,
          { serviceProvider: isAuthenticated()?.serviceProviderId, pageSize: 500, pageNo: 0 },
          { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
        );
        setEmployees(res.data?.data || []);
      } catch (err) {
        generalErrorAlert(err);
      }
    };
    load();
  }, []);

  return (
    <Card title={t("Payroll filings")}>
      <PayrollReports employees={employees} />
    </Card>
  );
};

export default PayrollReportsPage;
